<!-- 手工监测站弹框 -->
<template>
  <div class="dialog-manual-monitor">
    <div class="header">
      <div class="title f-size-24 f-col-white08">{{ data.dmmc }}</div>
      <div class="btn" @click="traceSource">污染溯源</div>
    </div>
    <div class="body">
      <div class="descriptions-item point">
        <span class="key">主要超标污染物:</span>
        <span class="value">{{ data.zyCbWry }}</span>
        <!-- <span class="value">总氮（监测值：1.248，超标倍数0.238）</span> -->
      </div>
      <div class="newest-parameter">
        <div class="title">
          <!-- {{ parameter.title }} -->
          <!-- 最新水质参数（{{ data.jcsj ? data.jcsj : '-' }}）： -->
          最新水质参数：
        </div>
        <div class="parameter">
          <div class="parameter-box">
            <div v-for="(item, index) in data.quality" :key="index" class="data-box">
              <div class="box-content">
                <div class="value" :class="getFontSize(item.value)">
                  {{ item.value || item.value === 0 ? item.value : '-' }}
                </div>
                <div class="key">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <!-- <div class="data-box" v-for="(item, index) in parameter.data" :key="index">
            <div class="box-content">
              <div class="value">{{ getParameter(item.key) }}</div>
              <div class="key">{{ item.key }}</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="echart">
        <div class="header">
          <div class="left">
            <div
              v-for="(item, index) in data.waterTrendData"
              :key="index"
              class="echart-btn"
              :class="{ active: selectFactor.code === item.code }"
              @click="select(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="right"></div>
        </div>
        <div class="body">
          <AutoMonitor ref="autoMonitor" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted, defineEmits } from 'vue'
import { ref } from 'vue-demi'
import Bus from '@/config/Bus'
import { Api, DmYzDatumLineQuery } from '@/api/publicApi'
import AutoMonitor from '../charts/AutoMonitor.vue'

const props = defineProps({
  data: Object,
})
const api = new Api()
const emit = defineEmits(['close'])

const autoMonitor = ref()
const options = []
const selectFactor = ref({code:""})
const echartTime = ref('H')
const startTime = new Date()
const parameter = {
  title: '',
  data: [],
}
const select = async (val) => {
  switch (val) {
    case 'H':
      echartTime.value = 'H'
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName);
      break
    case 'D':
      echartTime.value = 'D'
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName);
      break
    default:
      selectFactor.value = val
      await getTrend()
      // this.$refs.autoMonitor.initChart(testX, testY, this.selectFactor.factorName, {
      //   standValues: val.standValues,
      //   unit: val.unit,
      // });
      break
  }
}
const getFontSize = (value: any) => {
  let className = ''
  let val = value
  if (!value) {
    return className
  }
  if (typeof value === 'number') {
    val = `${value}`
  }
  if (val.length < 6) {
    className = 'font-size48'
  } else if (val.length < 10) {
    className = 'font-size40'
  } else {
    className = 'font-size34'
  }
  return className
}
// 获取echart趋势数据
const getTrend = async () => {
  const data = []
  //   const data = await getMonitorDataListUsingGET({
  //     begin: this.formatDate(this.startTime, 'yyyy-MM-dd hh:mm:ss'),
  //     factor: this.selectFactor.factorCode,
  //     frequency: this.echartTime,
  //     mn: this.data.id,
  //   });
  const XData = []
  const YData = []
  for (let i = 0; i < data.length; i += 1) {
    XData.push(data[i].dataTime)
    YData.push(data[i].value)
  }

  let markLine
  const params: DmYzDatumLineQuery = {
    code: selectFactor.value.code,
    stlx: props.data.stlx,
    bzszlb: props.data.bzszlbdm,
  }
  await api.screen.getDmYzDatumLineUsingPost(params).then((res) => {
    if (res.code === 200) {
      markLine = res.data
    }
  })

  await autoMonitor.value.initChart(
    selectFactor.value.xaxis,
    selectFactor.value.trend,
    selectFactor.value.name,
    markLine
  )
}
const getYzCbBs = (array: any[]) => {
  let res = '无'
  if (array && array.length) {
    res = ''
    array.forEach((item, index) => {
      if (index + 1 < array.length) {
        res += `${item.factorName}（监测值：${item.monitorValue}，超标倍数：${item.cbbs}），`
      } else {
        res += `${item.factorName}（监测值：${item.monitorValue}，超标倍数：${item.cbbs}）`
      }
    })
  }
  return res
}

// 污染溯源
const traceSource = () => {
  // Bus.emit('closeModal')
  const data1 = {
    ...props.data,
  }
  Bus.emit('mapClick', {
    data: { ...data1 },
    modalType: '污染溯源',
  })
}
const changeTime = () => {
  getTrend()
}
onMounted(() => {
  if (props.data.waterTrendData && props.data.waterTrendData.length) {
    select(props.data.waterTrendData[0])
  } else {
    getTrend()
  }
})
</script>

<style lang="scss" scoped>
.dialog-manual-monitor {
  width: 81.8rem;
  height: 54.35rem;
  .header {
    text-align: left;
    margin-bottom: 2rem;
    position: relative;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 3.15rem;
      line-height: 3.15rem;
    }
    .btn {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 6.2rem;
      text-align: center;
      font-size: 1.3rem;
      color: #ffffff;
      cursor: pointer;
      background: rgba(102, 146, 138, 0.1);
      border: 0.025rem solid #42c4dbcc;
      box-sizing: border-box;
      border-radius: 0.1rem;
    }
  }
  .body {
    .point {
      font-size: 14px;
      line-height: 1.6rem;
      margin-bottom: 10px;
      .key {
        margin-right: 2rem;
      }
      .value {
        color: #fff825;
      }
    }

    .newest-parameter {
      margin-bottom: 3rem;
      .title {
        text-align: left;
        font-size: 14px;
        line-height: 1.6rem;
        margin-bottom: 1rem;
      }
      .parameter {
        display: flex;
        height: 8.2rem;
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        padding-bottom: 1.2rem;
        &::-webkit-scrollbar {
          display: block;
        }
        &::-webkit-scrollbar {
          height: 0.6rem;
        }
        /* 滚动槽 */
        &::-webkit-scrollbar-track {
          -webkit-box-shadow: rgba(13, 220, 227, 0.5);
          border-radius: 1rem;
        }
        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 1rem;
          background: rgba(13, 220, 227, 0.5);
          -webkit-box-shadow: rgba(13, 220, 227, 0.5);
        }
        &::-webkit-scrollbar-thumb:window-inactive {
          background: rgba(13, 220, 227, 0.5);
        }
        // justify-content: space-between;
        .parameter-box {
          display: flex;
        }
        .data-box {
          width: 80px;
          height: 82px;
          margin-right: 1.5rem;
          background-color: #68c1dc4d;
          padding: 0.675rem 0;
          box-sizing: border-box;
          text-align: center;
          .box-content {
            height: 5.35rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .value {
              color: #00ffe1;
              font-size: 2rem;
              height: 3.25rem;
              line-height: 3.25rem;
            }
            .key {
              font-size: 1.5rem;
              height: 2rem;
              line-height: 2rem;
              color: #ffffff;
            }
          }
        }
      }
    }

    .echart {
      * {
        font-size: 1.4rem;
      }
      .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 2rem;
        .left {
          // display: flex;
          .echart-btn {
            float: left;
            padding: 0 0.6rem;
            height: 2.65rem;
            line-height: 2.65rem;
            margin-right: 0.9rem;
            background-color: transparent;
            border: 0.025rem solid transparent;
            color: #8ec0ce;
            &:last-of-type {
              margin-right: 0;
            }
          }
        }

        .right {
          display: flex;
          .echart-btn {
            width: 5.6rem;
            height: 28px;
            line-height: 28px;
            font-size: 1.2rem;
            box-sizing: border-box;
            color: #ffffff99;
          }
          .map-dialog {
            width: 8.7rem;
            height: 2.4rem;
            line-height: 0;
            box-sizing: border-box;
            margin-left: 0.5rem;
          }
        }
      }
      .echart-btn {
        background: rgba(102, 146, 138, 0.1);
        border: 0.025rem solid rgba(102, 146, 138, 0.8);
        border-radius: 0.1rem;
        cursor: pointer;
        text-align: center;
        &.active,
        &:hover {
          background: #00acff !important;
          border: 0.025rem solid rgba(102, 146, 138, 0.8);
          color: #ffffff !important;
        }
      }
    }
  }

  .font-size48 {
    font-size: 2.4rem !important;
  }

  .font-size40 {
    font-size: 2rem !important;
  }

  .font-size34 {
    font-size: 1.7rem !important;
  }
}
</style>
